import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';
import moment from 'moment';

import { Modal, message, Progress, Popover, Tag } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function () {

    }
}

const params = {
    domain: {}
};

const headers = utils.columns([
    { key: '$index', label: '序号', width: 75 },
    { key: 'classTime', label: '开课时间', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'lessonNum', label: '节次', width: 60 },
    { key: 'lessonAddress', label: '教室', width: 150 },
    { key: 'weekName', label: '星期', width: 60 },
    { key: 'classWeek', label: '听课周次', width: 80, render: (value) => value ? `第${value}周` : "" },
    {
        key: 'selectionState', width: 80, label: '选课状态', render: (value) => {
            if (value === 1) {
                return <span style={{ textAlign: "center", display: "block" }}><Tag color="#0684e2" >{"可选"}</Tag></span>
            } else {
                return <span style={{ textAlign: "center", display: "block" }}><Tag color="#ddd">{"选满"}</Tag></span>
            }
        }
    },
    { key: 'selectionNum', label: '被选次数', width: 120 },
    {
        key: 'submitState', label: '选课操作', width: 90,
        render: (d, row, callback) =>
            <a href="javascript:;"
                className="sumbit-button"
            ><i class="fa fa-check" style={{ color: '#52c41a' }} aria-hidden="true"></i>&nbsp;选课</a>
    },
    {
        key: 'submitState', label: '提交状态', width: 80, render: (value) => {
            if (value === '1') return "预提交";
            else if (value === '2') return "正式提交";
            else return "";
        }
    }
]);



/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('course/plan/selection/task/get/' + id, {})
        .then(response => response.payload.data)
        .catch(error => {
        });
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
 const authorityCheck = () => {
    return fetch.get('course/plan/selection/task/authorityCheck', {})
        .then(response => response.payload.data)
        .catch(error => {
        });
}


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('course/plan/selection/task/select/list', Object.assign(defaultsParams, keywords))
        .then(response => {
            let paramValue = response.payload.meta.extParams.paramValue || ",";
            if (paramValue && paramValue.startsWith("[")) {
                paramValue = paramValue.slice(1, paramValue.length); // 去掉首尾括号
            }
            if (paramValue && paramValue.endsWith("]")) {
                paramValue = paramValue.slice(0, -1); // 去掉首尾括号
            }
            const paramValueArray = paramValue.split(',');

            const columns = [
                { key: '$index', label: '序号', width: 75 },
            ];
            if (paramValueArray.includes('orgName')) {
                columns.push(
                    { key: 'orgName', label: '开课学院', width: 150 },
                )
            }
            if (paramValueArray.includes('courseName')) {
                columns.push(
                    { key: 'courseName', label: '课程名称', width: 150 },
                )
            }
            if (paramValueArray.includes('classesName')) {
                columns.push(
                    { key: 'classesName', label: '班级', width: 150 },
                )
            }
            if (paramValueArray.includes('evalTypeName')) {
                columns.push(
                    { key: 'evalTypeName', label: '测评类型', width: 60 },
                )
            }
            if (paramValueArray.includes('employeeCode')) {
                columns.push(
                    { key: 'employeeCode', label: '教师工号', width: 100 },
                )
            }
            if (paramValueArray.includes('employeeName')) {
                columns.push(
                    { key: 'employeeName', label: '教师', width: 100 },
                )
            }
            if (paramValueArray.includes('attendCoursePersonName')) {
                columns.push(
                    { key: 'attendCoursePersonName', label: '听课人', width: 120, render: value => value ? value.substring(1, value.length - 1) : value },
                )
            }
            if (paramValueArray.includes('classTime')) {
                columns.push(
                    { key: 'classTime', label: '开课时间', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
                )
            }
            if (paramValueArray.includes('lessonNum')) {
                columns.push(
                    { key: 'lessonNum', label: '节次', width: 60 },
                )
            }
            if (paramValueArray.includes('lessonAddress')) {
                columns.push(
                    { key: 'lessonAddress', label: '教室', width: 150 },
                )
            }
            if (paramValueArray.includes('weekName')) {
                columns.push(
                    { key: 'weekName', label: '星期', width: 60 },
                )
            }
            if (paramValueArray.includes('classGrade')) {
                columns.push(
                    { key: 'classGrade', label: '年级', width: 100 },
                )
            }
            if (paramValueArray.includes('weekNumBg')) {
                columns.push(
                    { key: 'weekNumBg', label: '开始周', width: 80 },
                )
            }
            if (paramValueArray.includes('weekNumEnd')) {
                columns.push(
                    { key: 'weekNumEnd', label: '结束周', width: 80 },
                )
            }
            if (paramValueArray.includes('classWeek')) {
                columns.push(
                    { key: 'classWeek', label: '听课周次', width: 80, render: (value) => value ? `第${value}周` : "" },
                )
            }
            if (paramValueArray.includes('deadline')) {
                columns.push(
                    { key: 'deadline', label: '选课截止日期', width: 120, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
                )
            }
            columns.push(
                {
                    key: 'selectionState', width: 80, label: '选课状态', render: (value) => {
                        if (value === 1) {
                            return <span style={{ textAlign: "center", display: "block" }}><Tag color="#0684e2" >{"可选"}</Tag></span>
                        }
                        else if (value === 2) {
                            return <span style={{ textAlign: "center", display: "block" }}><Tag color="#bbb" >{"已选"}</Tag></span>
                        }
                        else if (value === 3) {
                            return <span style={{ textAlign: "center", display: "block" }}><Tag color="#f31b27" >{"截止"}</Tag></span>
                        }
                        else {
                            return <span style={{ textAlign: "center", display: "block" }}><Tag color="#bbb">{"选满"}</Tag></span>
                        }
                    }
                }
            )
            columns.push({ key: 'selectionNum', label: '被选次数', width: 120 })
            columns.push(
                {
                    key: 'submitState', label: '选课操作', width: 90,
                    render: (d, row, callback) => (+row.selectionState === 1 ?
                        <a href="javascript:;"
                            className="sumbit-button"
                            onClick={() => {
                                Modal.confirm({
                                    title: '确定选课？',
                                    content: '选课完毕，请正式提交（预提交的，系统将会在24小时内自动正式提交）',
                                    okText: "确认",
                                    cancelText: "取消",
                                    onOk: () => {
                                        fetch.post('/course/plan/selection/task/submit', [row.id])
                                            .then(response => {
                                                if (response.code === 200) {
                                                    const data = response.payload.data;
                                                    if (data && data.overLimit === 0 &&
                                                        data.surplus === 0 && data.nullValue === 0 && data.isTeacher === 0) {
                                                        message.success("预选成功！您可以点击正式提交完成选课");
                                                    }
                                                    else if (data.overLimit != 0) {
                                                        message.error("选课人数已经超过限定人数");
                                                    }
                                                    else if (data.surplus != 0) {
                                                        message.error("已选则该课程，请勿重复选课");
                                                    }
                                                    else if (data.nullValue != 0) {
                                                        message.error("未找到相关信息，请稍后尝试");
                                                    }
                                                    else if (data.isTeacher != 0) {
                                                        message.error("选课失败，上课人和选课人不能一致！");
                                                    }

                                                    callback();
                                                }
                                            });
                                    },
                                    onCancel: () => { },
                                });

                            }}
                        ><i class="fa fa-check" style={{ color: '#52c41a' }} aria-hidden="true"></i>&nbsp;选课</a> : "")
                }
            );
            columns.push(
                {
                    key: 'submitState', label: '提交状态', width: 80, render: (value) => {
                        if (value === '1') return "预提交";
                        else if (value === '2') return "正式提交";
                        else return "";
                    }
                });
            columns.push(
                {
                    key: 'submitSituation', label: '提交情况', width: 80, render: (value) => {
                        if (value === 1) return <span style={{ marginLeft: '2px' }}>
                            <i class="fa fa-circle" aria-hidden="true" style={{ color: '#31b431' }}></i>
                        </span>;
                        else return <span style={{ marginLeft: '2px' }}>
                            <i class="fa fa-circle" aria-hidden="true" style={{ color: '#f5222d' }}></i>
                        </span>;
                    }
                });
            return {
                headers: utils.columns(columns),
                data: response.payload.data,
            };
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}


/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('course/plan/selection/insert', data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '信息添加成功!',
                    content: (
                        <div>
                            <p>点击确认后，将自动跳转到管理页面！</p>
                        </div>
                    ),
                    onOk() {
                        // window.location.hash = '/plan/CoursePlanSimple/index';
                    },
                    okText: "确认",
                });
            }

        });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('course/plan/selection/update/' + id, data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '教学系统课表信息更新成功!',
                    content: (
                        <div>
                            <p>点击确认后，将自动跳转到选课发布页面！</p>
                        </div>
                    ),
                    onOk() {
                        // window.location.hash = 'course/plan/index';
                    },
                    okText: "确认",
                });
            }
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('course/plan/selection/task/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method formalSubmit
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const formalSubmit = (ids) => {
    return fetch.post('course/plan/selection/task/formalSubmit', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method selectTaskCancel
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const selectTaskCancel = (ids) => {
    return fetch.post('course/plan/selection/task/selectTaskCancel', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}


/**
 * @method batchSubmit
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchSubmit = (ids) => {
    return fetch.post('course/plan/selection/task/submit', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}


/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback, setLoading) => {
    return new Promise(function (resolve, reject) {
        if (DataGrid.selections.length === 0) {
            Modal.error({
                title: '请先选择一项或多项！',
                content: '只有勾选一项或多项后才能删除！',
            });
        } else {
            Modal.confirm({
                title: '确定删除该记录？',
                content: '删除后将无法恢复！',
                onOk() {
                    setLoading ? setLoading(true) : "";
                    remove(DataGrid.selections).then(response => {
                        if (response.code === 200) {
                            if (response.payload.data.fail === 0) {
                                message.success(response.message);
                            } else {
                                message.warn("删除操作： 成功" + response.payload.data.success + "个;失败" + response.payload.data.fail + "个\n"
                                    + "存在已测评的记录，请删除测评结果后再进行删除！"
                                )
                            }

                            resolve();
                            DataGrid.selections = [];
                            callback();
                        } else {
                            reject();
                        }
                    });
                },
                onCancel() { },
                okText: "确认",
                cancelText: "取消"
            });
        }
    })
}

/**
 * @method expprtData
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const expprtData = (data) => {
    const ids = DataGrid.selections;
    return fetch.post('course/plan/simple/publish', Object.assign({}, data, { ids }))
        .then(response => {
            params.domain = {};
            if (response.code === 200) {
                return response.payload.data.studentCourseInt;
            }
            return 0;
        });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const getSelectionData = () => {
    return DataGrid.selectData;
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
const exportList = (keywords) => {
    return fetch.download('course/plan/selection/task/export', keywords, "听课任务信息数据导出.xls")
}

const getCourseListener = (id) => {
    return fetch.post(`course/plan/selection/task/getCourseListener/${id}`, {})
}

const updateAttendCoursePerson = (id, params) => {
    return fetch.post(`course/plan/selection/task/updateAttendCoursePerson/${id}`, params)
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
const exportSelectionList = (keywords) => {
    return fetch.download('course/plan/selection/task/selection/export', keywords, "听课任务信息数据导出.xls")
}

/**
 * @method fallback
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const fallback = (ids) => {
    return fetch.post('course/plan/selection/task/fallback', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    onSelectData,
    batchRemove,
    setRefresh,
    getSelection,
    getSelectionData,
    expprtData,
    params,
    exportList,
    getCourseListener,
    updateAttendCoursePerson,
    exportSelectionList,
    formalSubmit,
    selectTaskCancel,
    batchSubmit,
    fallback,
    authorityCheck
}